//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO O CARD COM A DESCRIÇÃO, FOTO E         //
//  QUANTIDADE DE ITENS COMPRADOS DE CADA PRODUTO       //
//  NA PÁGINA DE PEDIDOS (PARA FRANQUEADOS) E NA        //
//  PÁGINA DE PEDIDOS_CLIENTE (PARA CLIENTES)           //   
//                                                      //   
//  FUNCIONALIDADE: MOSTRAR CARD DOS PRODUTOS           //    
//    DE CADA PEDIDO                                    //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/pedidos_cliente.js                           //
//      frontend/src/pages/pedidos.js                                   //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import MockPictureFranqueado from  './mock_picture_franqueado';

import '../assets/css/local/header.css';


function PrecoPictureQuantidadeFranqueado(props) {

  // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
    // 'MockPictureFranqueado' -> PARTE DA FOTO NO CARD DOS PRODUTOS QUE APARECEM NAS PÁGINAS DE PEDIDO

  return (
    <div class="mb-5">

      <div class='px-1 border mx-2 produto-card-franqueado mb-0'>
        <div class="center preco_carrinho mw-picture titulo-card">
          {props.dsc}
        </div>

        <MockPictureFranqueado props={props}/>
        <div class="montserrat px-5 pb-3">
          Quantidade: {props.qnt}
        </div>
      </div>

    </div>
  );
 }

  export default PrecoPictureQuantidadeFranqueado;
  

 